import type { IconSet, IconStyle, SocialNetwork } from '../types'
import iconData from './socialIcons.json'

export const ICON_SETS: IconSet[] = ['brand', 'dark', 'light']

type IconDef = { paths: string[]; fillRule?: 'evenodd' | 'nonzero' }

const networks = iconData.networks as Record<SocialNetwork, IconDef>
const brandColors = iconData.brandColors as Record<SocialNetwork, string>
const setInk = iconData.setInk as Record<'dark' | 'light', string>

export const getIconDef = (network: SocialNetwork): IconDef => networks[network]

export interface ResolvedIconColors {
  /** Disc fill for `filled` style, else `null` (transparent). */
  background: string | null
  /** Ring color for `outline` style, else `null`. */
  ring: string | null
  /** Glyph (path) fill. */
  glyph: string
}

/**
 * Resolve the three render colors for a (network, set, style) combo. This is the
 * single source of truth shared by the editor preview (SocialNetworkIcon.vue) and
 * the PNG generator (scripts/generate-social-icons.mjs) — keep both in sync.
 *
 * - `brand`: each network in its native color.
 * - `dark` / `light`: monochrome ink.
 * On a `filled` disc the glyph flips to a contrasting color so it stays legible.
 */
export const resolveIconColors = (network: SocialNetwork, set: IconSet, style: IconStyle): ResolvedIconColors => {
  const base = set === 'brand' ? brandColors[network] : setInk[set]

  if (style === 'filled') {
    return {
      background: base,
      ring: null,
      glyph: set === 'light' ? setInk.dark : '#ffffff'
    }
  }

  if (style === 'outline') {
    return { background: null, ring: base, glyph: base }
  }

  return { background: null, ring: null, glyph: base }
}
